import { RecommendationsTitle, RecommendationsSubtitle, RecommendationsTitleTag, RecommendationsFooter, withCarouselContainer } from '@recommendations-fe/commons';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _jsx from '@babel/runtime/helpers/jsx';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.array.push.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { useRef, useState, useEffect, createElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { namespaceRecommendations } from '@recommendations-fe/commons/namespaces';
import { jsxs, jsx } from 'react/jsx-runtime';
const _excluded = ["ListComponent", "listType", "className", "classnameFromResponse", "paddingHorizontal", "onTitleTagClick"];
function ownKeys$7(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$7(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const RecommendationsList$1 = _ref => {
  let {
      ListComponent,
      listType,
      className,
      classnameFromResponse,
      paddingHorizontal,
      onTitleTagClick
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const namespace = "".concat(namespaceRecommendations, "-list");

  // Misc components props
  const {
    items,
    title,
    titleWithIcons,
    titleTag,
    subtitle,
    footer,
    href,
    IconFactory
  } = rest;

  // Card Height Setting
  const listRef = useRef();
  const [isJsLoaded, setIsJsLoaded] = useState(false);
  /* istanbul ignore next */
  useEffect(() => {
    if (listRef.current) {
      const listWrapper = listRef.current.querySelector(".".concat(namespaceRecommendations, "-list__items-wrapper--horizontal"));
      if (listWrapper) {
        const listWrapperPaddingBottom = parseFloat(window.getComputedStyle(listWrapper).paddingBottom) || 0;
        const maxCardHeight = listWrapper.getBoundingClientRect().height - listWrapperPaddingBottom;
        const maxCardHeightValue = maxCardHeight > 0 ? "".concat(maxCardHeight, "px") : 'auto';
        listRef.current.style.setProperty('--max-card-height', maxCardHeightValue);
      }
    }
    setIsJsLoaded(true);
  }, [listRef]);
  return items && items.length > 0 && /*#__PURE__*/jsxs("div", {
    className: classNames(namespace, "".concat(namespace, "__container--").concat(listType || 'generic'), className, classnameFromResponse),
    ref: listRef,
    style: {
      '--list-padding': "".concat(paddingHorizontal, "px")
    },
    children: [title && /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__header")
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__header-titles")
    }, void 0, /*#__PURE__*/_jsx(RecommendationsTitle, {
      title: title,
      titleWithIcons: titleWithIcons,
      href: href,
      IconFactory: IconFactory
    }), subtitle && /*#__PURE__*/_jsx(RecommendationsSubtitle, {
      text: subtitle.text,
      url: subtitle.url,
      IconFactory: IconFactory,
      advertisingLabel: subtitle.advertising_label
    }), titleTag && /*#__PURE__*/_jsx(RecommendationsTitleTag, {
      text: titleTag.text,
      values: titleTag.values,
      styles: titleTag.styles,
      IconFactory: IconFactory,
      onTitleTagClick: onTitleTagClick
    }))), ListComponent && /*#__PURE__*/jsx(ListComponent, _objectSpread$7({
      listType: listType,
      disableHover: !isJsLoaded
    }, rest)), footer && /*#__PURE__*/_jsx(RecommendationsFooter, {
      footerText: footer.text,
      href: footer.link,
      IconFactory: IconFactory,
      withChevron: true
    })]
  });
};
RecommendationsList$1.defaultProps = {
  paddingHorizontal: 0
};
const priceShape = PropTypes.shape({
  currency_id: PropTypes.string,
  symbol: PropTypes.string,
  fraction: PropTypes.string.isRequired,
  decimal_separator: PropTypes.string,
  cents: PropTypes.string
});
({
  /**
   * Required properties
   */
  /**
   * Optional properties
   */
  image: PropTypes.shape({
    src: PropTypes.string,
    src2x: PropTypes.string,
    size: PropTypes.string
  }),
  id: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  condition: PropTypes.string,
  className: PropTypes.string,
  tracking: PropTypes.string,
  bookmarked: PropTypes.bool,
  attributes: PropTypes.string,
  lazyLoad: PropTypes.bool,
  /**
   * Shaped props
   */
  price: priceShape,
  installments: PropTypes.shape({
    freeInstallments: PropTypes.bool,
    text: PropTypes.string.isRequired
  }),
  shipping: PropTypes.shape({
    text: PropTypes.string,
    freeShipping: PropTypes.bool,
    fullfilment: PropTypes.bool,
    promise: PropTypes.shape({
      text: PropTypes.string.isRequired,
      highlight: PropTypes.bool
    })
  }),
  brand: PropTypes.PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    logoSrc: PropTypes.string.isRequired,
    logoSrc2x: PropTypes.string
  }),
  discount: PropTypes.shape({
    text: PropTypes.string.isRequired,
    original_price: priceShape.isRequired
  }),
  review: PropTypes.shape({
    stars: PropTypes.number.isRequired,
    total: PropTypes.number
  }),
  actions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired
  })),
  animation: PropTypes.string,
  isLoyalDiscount: PropTypes.bool
});
function ownKeys$6(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$6(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const RecommendationsListBase = _ref => {
  let {
    Card,
    IconFactory,
    items,
    title,
    listType,
    priceSizeOverride,
    hideRebates,
    onItemClick,
    onBookmarkClick,
    bookmarkedItems,
    bookmarkText,
    classNamesMap = {},
    classNamesIndexMap = {},
    disableHover
  } = _ref;
  const namespace = "".concat(namespaceRecommendations, "-list__items-wrapper--").concat(listType);
  return /*#__PURE__*/_jsx("ul", {
    className: namespace,
    "aria-label": title
  }, void 0, items && items.map((item, index) => {
    var _item$id;
    const ItemID = (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : item === null || item === void 0 ? void 0 : item.metadata.id;
    const classNameFromMap = classNamesMap[item.id];
    /* eslint-disable-next-line security/detect-object-injection */
    const classNameFromIndex = classNamesIndexMap[index];
    const CardToUse = item.CustomCard || Card;
    return /*#__PURE__*/createElement(CardToUse, _objectSpread$6(_objectSpread$6({}, item), {}, {
      key: ItemID,
      classNameFromMap: classNameFromMap,
      classNameFromIndex: classNameFromIndex,
      IconFactory: IconFactory,
      onItemClick: onItemClick,
      onBookmarkClick: onBookmarkClick,
      bookmarkedItems: bookmarkedItems,
      bookmarkText: bookmarkText,
      priceSizeOverride: priceSizeOverride,
      hideRebates: hideRebates,
      isListItem: true,
      disableHover: disableHover,
      cardNumber: index
    }));
  }));
};
RecommendationsListBase.defaultProps = {
  hideRebates: false
};
function ownKeys$5(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$5(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const priceSizeOverride$5 = {
  price: 20,
  discount: 12,
  installments: 14,
  original: 12
};
const RecommendationsListDefault = props => /*#__PURE__*/jsx(RecommendationsListBase, _objectSpread$5({
  priceSizeOverride: priceSizeOverride$5
}, props));
function ownKeys$4(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$4(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const priceSizeOverride$4 = {
  price: 24,
  discount: 14,
  installments: 14,
  original: 12
};
const RecommendationsListSingle = props => /*#__PURE__*/jsx(RecommendationsListBase, _objectSpread$4({
  priceSizeOverride: priceSizeOverride$4
}, props));
function ownKeys$3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const priceSizeOverride$3 = {
  price: 24,
  discount: 12,
  installments: 14,
  original: 12
};
const RecommendationsListDouble = props => /*#__PURE__*/jsx(RecommendationsListBase, _objectSpread$3({
  priceSizeOverride: priceSizeOverride$3
}, props));
function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const priceSizeOverride$2 = {
  price: 16,
  discount: 12,
  installments: 12,
  original: 12
};
const RecommendationsListGrid = props => /*#__PURE__*/jsx(RecommendationsListBase, _objectSpread$2({
  priceSizeOverride: priceSizeOverride$2
}, props));
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const priceSizeOverride$1 = {
  price: 20,
  discount: 14,
  installments: 14,
  original: 14
};
const RecommendationsListPads = props => /*#__PURE__*/jsx(RecommendationsListBase, _objectSpread$1({
  priceSizeOverride: priceSizeOverride$1
}, props));
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const priceSizeOverride = {
  price: 20,
  discount: 12,
  installments: 12,
  original: 12
};
const RecommendationsListHorizontal = props => /*#__PURE__*/jsx(RecommendationsListBase, _objectSpread({
  priceSizeOverride: priceSizeOverride
}, props));
const RecommendationsList = withCarouselContainer(RecommendationsList$1);
export { RecommendationsList, RecommendationsListDefault, RecommendationsListDouble, RecommendationsListGrid, RecommendationsListHorizontal, RecommendationsListPads, RecommendationsListSingle, RecommendationsList$1 as RecommendationsListWithoutContainer };
